// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatListFilesBody = {
  chatId: string;
  cursor?: string | null;
  limit?: number | null;
};

export type typeChatListFilesOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      messageId: string;
      mediaObjectId: string;
      kind: "pdf";
      sentAtIso: string;
      fileName: string;
      byteSize?: number | null;
    }[];
    nextCursor?: string | null;
  };
};

export type typeChatListFilesOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatListFilesOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatListFilesOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatListFilesBody = {
  type: "object",
  properties: {
    chatId: { type: "string", maxLength: 3000, minLength: 1 },
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
  required: ["chatId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatListFiles(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatListFilesBody);
  }

  return async function postChatListFiles(
    payload: typeChatListFilesBody,
  ): Promise<typeChatListFilesOutput200 | typeChatListFilesOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatListFiles" failed before calling the network. #fb07fa028b73`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#fb07fa028b73" },
        },
        data: null,
      } as typeChatListFilesOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat/list-files`,
      httpMethod: "POST",
      options,
    })) as typeChatListFilesOutput200 | typeChatListFilesOutput400;
  };
}
